module.exports = __webpack_public_path__ + "570b4f56ba4049fbef4f3143a66c03f3.png";